export const legalBaseOptions = [
  { name: 'Consentimento (Art. 7, I)' },
  { name: 'Obrigação Legal ou Regulatória (Art. 7, II)' },
  { name: 'Execução de Políticas Públicas (Art. 7, III)' },
  { name: 'Estudos por Órgãos de Pesquisa (Art. 7, IV)' },
  { name: 'Execução de Contrato (Art. 7, V)' },
  { name: 'Exercício Regular de Direito (Art. 7, VI)' },
  { name: 'Proteção da Vida ou Incolumidade Física (Art. 7, VII)' },
  { name: 'Tutela da Saúde (Art. 7, VIII)' },
  { name: 'Interesse Legítimo (Art. 7, IX)' },
  { name: 'Proteção do Crédito (Art. 7, X)' },
];

export const legalBaseSensitivyOptions = [
  { name: 'Consentimento (Art. 11, I)' },
  { name: "Obrigação Legal ou Regulatória (Art. 11, II, 'a')" },
  { name: "Execução de Políticas Públicas (Art. 11, II, 'b')" },
  { name: "Estudo por Órgãos de Pesquisa (Art. 11, II, 'c')" },
  { name: "Exercício Regular de Direitos (Art. 11, II, 'd')" },
  { name: "Proteção da Vida ou Incolumidade Física (Art. 11, II, 'e')" },
  { name: "Tutela da Saúde (Art. 11, II, 'f')" },
  { name: "Prevenção à Fraude e Segurança do Titular (Art. 11, II, 'g')" },
  { name: 'N/A' },
];
